import React from "react";

const SectionGuard = ({
  result,
  children,
  fallback = null,
  notFoundFallback = null,
  hideOnNotFound = true,
  logLabel = "Section",
}) => {
  if (!result) {
    return children || null;
  }

  if (result.reason === "NOT_FOUND") {
    if (hideOnNotFound) {
      return null;
    }
    return notFoundFallback ?? fallback ?? null;
  }

  if (!result.ok) {
    console.warn(`[SectionGuard] ${logLabel} unavailable`, result);
    return fallback ?? null;
  }

  return children || null;
};

export default SectionGuard;
